/**
 * admin.section of the foresight modules (#630). The work happens in the
 * user-facing foresight views (/ennakointi/…); this card says whether the
 * step's output is ready. The scope and
 * tulevaisuuskuvat steps also list the scenarios for the facilitator to take on
 * to further work or to publish (ForesightRunsAdmin).
 */
import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation.jsx';
import { stepLabelKey } from '../../../foresight/foresightSteps';
import { Card, Muted } from './moduleSectionStyles';
import ForesightRunsAdmin from './ForesightRunsAdmin';

// The steps whose card carries the facilitator's scenario decisions.
const DECIDES = new Set(['foresight_scope.v1', 'scenarios.v2']);

export default function ForesightStepAdmin({ instanceId, step }) {
  const { t } = useTranslation();
  const done = Boolean(step?.hasContent);
  return (
    <Card>
      <Muted>{t(stepLabelKey(step?.moduleId))}: {done ? t('foresight.admin.statusDone') : t('foresight.admin.statusOpen')}</Muted>
      {DECIDES.has(step?.moduleId) && <ForesightRunsAdmin instanceId={instanceId} moduleId={step.moduleId} />}
    </Card>
  );
}
